module.exports = __webpack_public_path__ + "img/Susy.2b23fa27.png";